'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchCurrentUserSubscription = exports.fetchCurrentUserReferrals = exports.uploadCurrentUserAvatar = exports.userImageUploadError = exports.userImageUploadCompleted = exports.setUserImage = exports.setCurrentUserGuest = exports.refreshCurrentUser = exports.updateCurrentUserHtpp = exports.fetchCurrentUser = exports.userNavigate = exports.updateCurrentUser = exports.setCurrentUser = undefined;

var _lodash = require('lodash');

var _http = require('../utils/services/http');

var _authService = require('./../auth/authService');

var _mediaService = require('../utils/services/mediaService');

var _mediaService2 = _interopRequireDefault(_mediaService);

var _userService = require('./userService');

var _elementActions = require('../element/elementActions');

var _navigationActions = require('../reducers/navigationActions');

var _userActions = require('../../common/users/userActions');

var _userActions2 = require('./userActions');

var _elementCountActions = require('../user/elementCount/elementCountActions');

var _teamManagementActions = require('./account/team/teamManagementActions');

var _imageFileLoader = require('../utils/services/image/imageFileLoader');

var _imageFileLoader2 = _interopRequireDefault(_imageFileLoader);

var _timeUtil = require('../../common/utils/timeUtil');

var _idValidator = require('../../common/uid/idValidator');

var _currentUserConstants = require('./currentUserConstants');

var _userConstants = require('../../common/users/userConstants');

var _mediaConstants = require('../../common/media/mediaConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Util


// Actions
var setCurrentUser = exports.setCurrentUser = function setCurrentUser(user) {
    return {
        type: _currentUserConstants.CURRENT_USER_SET,
        user: user
    };
};

// Constants
// Services
var updateCurrentUser = exports.updateCurrentUser = function updateCurrentUser(_ref) {
    var userId = _ref.userId,
        changes = _ref.changes,
        _ref$sync = _ref.sync,
        sync = _ref$sync === undefined ? true : _ref$sync;
    return function (dispatch, getState) {
        return dispatch((0, _userActions.updateUser)({
            userId: userId || getState().getIn(['app', 'currentUser', '_id']),
            changes: changes,
            sync: sync
        }));
    };
};

var userNavigate = exports.userNavigate = function userNavigate(_ref2) {
    var userId = _ref2.userId,
        newBoardId = _ref2.newBoardId,
        previousBoardId = _ref2.previousBoardId,
        _ref2$sync = _ref2.sync,
        sync = _ref2$sync === undefined ? true : _ref2$sync;
    return function (dispatch) {
        if (!(0, _idValidator.isElementId)(newBoardId)) return;

        dispatch({
            type: _userConstants.USER_NAVIGATE,
            newBoardId: newBoardId,
            previousBoardId: previousBoardId,
            timestamp: (0, _timeUtil.getTimestamp)(),
            userId: userId,
            sync: sync
        });
    };
};

var fetchCurrentUser = exports.fetchCurrentUser = function fetchCurrentUser() {
    return function (dispatch) {
        dispatch({ type: _currentUserConstants.CURRENT_USER_GET_DETAILS });

        var currentUserToken = (0, _authService.getCurrentUserToken)();

        // TODO review - might need to implement a redirect
        if (!currentUserToken) {
            console.error('Attempting to retrieve a user without a user token.');
            return;
        }

        (0, _userService.fetchMe)().then(function (response) {
            var _response$data = response.data,
                user = _response$data.user,
                elements = _response$data.elements,
                remoteUserIds = _response$data.remoteUserIds,
                elementCount = _response$data.elementCount;


            var userIds = (0, _lodash.keys)(remoteUserIds);
            var userShareCounts = (0, _lodash.mapValues)(remoteUserIds, function (shareCount) {
                return {
                    shareCount: shareCount
                };
            });

            dispatch(setCurrentUser(user));
            dispatch((0, _elementActions.loadElements)(elements));

            dispatch((0, _userActions2.trackUsers)(userIds));
            dispatch((0, _userActions2.loadUsers)(userShareCounts));

            dispatch((0, _elementCountActions.increaseElementCount)(elementCount));
        }).catch(function (err) {
            console.error(err, err.response);
            dispatch({ type: _currentUserConstants.CURRENT_USER_GET_FAILURE });
            dispatch((0, _navigationActions.navigateToLogin)());
        });
    };
};

var updateCurrentUserHtpp = exports.updateCurrentUserHtpp = function updateCurrentUserHtpp(userChanges) {
    return function (dispatch) {
        return (0, _userService.updateMe)({ userChanges: userChanges }).then(function (updatedUser) {
            return dispatch(updateCurrentUser({ userId: updatedUser._id, changes: updatedUser }));
        });
    };
};

var refreshCurrentUser = exports.refreshCurrentUser = function refreshCurrentUser() {
    return function (dispatch) {
        return (0, _userService.refreshMe)().then(function (response) {
            var user = response.data.user;

            dispatch((0, _userActions.refreshUser)({ userId: user._id, user: user }));
        });
    };
};

var setCurrentUserGuest = exports.setCurrentUserGuest = function setCurrentUserGuest() {
    return { type: _currentUserConstants.CURRENT_USER_SET_GUEST };
};

var setUserImage = exports.setUserImage = function setUserImage(_ref3) {
    var userId = _ref3.userId,
        imageData = _ref3.imageData;
    return {
        type: _currentUserConstants.CURRENT_USER_IMAGE_SET,
        userId: userId,
        imageData: imageData,
        sync: false
    };
};

var userImageUploadCompleted = exports.userImageUploadCompleted = function userImageUploadCompleted() {
    return {
        type: _currentUserConstants.CURRENT_USER_IMAGE_UPLOAD_COMPLETE,
        sync: false
    };
};

var userImageUploadError = exports.userImageUploadError = function userImageUploadError(error) {
    return {
        type: _currentUserConstants.CURRENT_USER_IMAGE_UPLOAD_ERROR,
        error: error,
        sync: false
    };
};

var uploadCurrentUserAvatar = exports.uploadCurrentUserAvatar = function uploadCurrentUserAvatar(userId, imageFile) {
    return function (dispatch, getState) {
        var state = getState();
        var isGuest = state.getIn(['app', 'currentUser', 'isGuest']);

        // Don't upload avatars for guests
        if (isGuest) return;

        // TODO Handle errors
        // Handles orientations of JPEGs if necessary
        return (0, _imageFileLoader2.default)(imageFile).then(function (_ref4) {
            var file = _ref4.file,
                imageDataUri = _ref4.imageDataUri;

            dispatch(setUserImage({ userId: userId, imageData: imageDataUri }));

            return _mediaService2.default.image.uploadMediaFile(file, { slug: userId, type: _mediaConstants.IMAGE_TYPES.AVATAR }).then(function (response) {
                dispatch(userImageUploadCompleted());
                dispatch(updateCurrentUser({ userId: userId, changes: response.data }));
            }).catch(function (err) {
                console.error('An error occurred while uploading the image', err, err.response);
                dispatch(userImageUploadError(err));
            });
        }).catch(function (err) {
            console.error('ERROR: reading uploaded avatar', err, err.response);
            return Promise.reject(err);
        });
    };
};

var fetchCurrentUserReferrals = exports.fetchCurrentUserReferrals = function fetchCurrentUserReferrals() {
    return function (dispatch, getState) {
        return (0, _http.http)({ url: 'users/me/referrals' }).then(function (_ref5) {
            var data = _ref5.data;

            var userId = getState().getIn(['app', 'currentUser', '_id']);
            var users = data.users,
                referrals = data.referrals;


            if (users) dispatch((0, _userActions2.loadUsers)(users));

            dispatch(updateCurrentUser({
                userId: userId,
                changes: {
                    referrals: referrals
                },
                sync: false
            }));
        }).catch(function (err) {
            return null;
        }) // not a big deal if this fails
        ;
    };
};

var fetchCurrentUserSubscription = exports.fetchCurrentUserSubscription = function fetchCurrentUserSubscription() {
    return function (dispatch, getState) {
        return (0, _http.http)({ url: 'users/me/subscription' }).then(function (_ref6) {
            var data = _ref6.data;

            var userId = getState().getIn(['app', 'currentUser', '_id']);
            var subscription = data.subscription,
                customer = data.customer;


            if (!subscription && !customer) return;

            dispatch(updateCurrentUser({
                userId: userId,
                changes: {
                    subscription: subscription,
                    customer: customer
                },
                sync: false
            }));

            var teamMembers = subscription.teamMemberIds;
            if (teamMembers.length > 1) {
                dispatch((0, _teamManagementActions.setTeamMembers)({ userIds: teamMembers }));
                dispatch((0, _userActions2.trackUsers)(teamMembers));
            }
        }).catch(function (err) {
            return null;
        }) // not a big deal if this fails
        ;
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/user/currentUserActions.js
// module id = 84
// module chunks = 0